<template>
	<PageContainer>
		<v-row>
			<v-col
				cols="12"
				sm="5"
			>
				<VForm ref="form">
					<AmeliproCard
						card-title="Informations personnelles"
						class="my-custom-margin"
					>
						<v-list>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title
										v-if="
											utilisateurExterneInfo.executant &&
												utilisateurExterneInfo.executant.rpps
										"
									>
										N° RPPS
									</v-list-item-title>
									<v-list-item-subtitle
										v-if="
											utilisateurExterneInfo.executant &&
												utilisateurExterneInfo.executant.rpps
										"
									>
										{{ utilisateurExterneInfo.executant.rpps }}
									</v-list-item-subtitle>
									<v-list-item-title v-if="utilisateurExterneInfo.numAm">
										N° AM
									</v-list-item-title>
									<v-list-item-subtitle v-if="utilisateurExterneInfo.numAm">
										{{ utilisateurExterneInfo.numAm }}
									</v-list-item-subtitle>
									<v-list-item-title
										v-if="
											utilisateurExterneInfo.executant &&
												utilisateurExterneInfo.isStructure
										"
									>
										N° Finess
									</v-list-item-title>
									<v-list-item-subtitle
										v-if="
											utilisateurExterneInfo.executant &&
												utilisateurExterneInfo.isStructure
										"
									>
										{{ utilisateurExterneInfo.executant.finess }}
									</v-list-item-subtitle>
									<v-list-item-title
										v-if="utilisateurExterneInfo.isDelegataire"
									>
										N° Identifiant
									</v-list-item-title>
									<v-list-item-subtitle
										v-if="utilisateurExterneInfo.isDelegataire"
									>
										{{ utilisateurExterneInfo.delegataire.numeroPrint }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title> Dénomination </v-list-item-title>
									<v-list-item-subtitle>
										{{ utilisateurExterneInfo.denominationComplet }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list>

						<v-list-item>
							<v-list-item-content>
								<div v-if="!editing">
									<v-list-item-title>
										E-mail
										<v-btn
											icon
											@click="toggleEdit"
										>
											<v-icon> {{ iconMdiPencil }}</v-icon>
										</v-btn>
									</v-list-item-title>
									<v-list-item-subtitle>
										{{ utilisateurExterneInfo.email }}
									</v-list-item-subtitle>
								</div>
								<div v-else>
									<AmeliproTextField
										id="newEmail"
										ref="newEmail"
										v-model="newEmail"
										bg-white
										label="Nouvelle adresse e-mail"
										:rules="emailRules"
									/>
									<AmeliproTextField
										id="newEmailDeux"
										v-model="newEmailDeux"
										bg-white
										label="Confirmation de l'adresse e-mail"
										:rules="emailRules"
									/>
									<AmeliproBtn
										class="mr-3"
										color="ap-white"
										hover-color="ap-blue lighten-3"
										text-color="ap-blue darken-1"
										bordered
										@click="toggleEdit"
									>
										Annuler
									</AmeliproBtn>
									<AmeliproBtn
										class="mr-3"
										icon-name="search"
										:disabled="!isFormValid()"
										@click="updateEmail"
									>
										Valider
									</AmeliproBtn>
								</div>
							</v-list-item-content>
						</v-list-item>
					</AmeliproCard>
				</VForm>
			</v-col>

			<v-col
				cols="12"
				sm="7"
			>
				<Contact />
			</v-col>
		</v-row>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import { Refs, VForm } from '@cnamts/vue-dot/src/types';

	import { store } from '@/store';

	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);

	import { updateUtilisateurApi } from '@/services/api/api';

	import { mdiPencil } from '@mdi/js';

	import { email } from '@cnamts/vue-dot/src/rules/email';
	import { required } from '@cnamts/vue-dot/src/rules/required';
	import Contact from '@/views/Profil/Contact.vue';

	@Component<InfoUtilisateurExterne>({
		components: {
			Contact
		}
	})
	export default class InfoUtilisateurExterne extends MixinsDeclaration {
		$refs!: Refs<{
			form: VForm;
		}>;

		iconMdiPencil = mdiPencil;
		newEmail = '';
		newEmailDeux = '';
		editing = false;
		isValidEMail = false;

		emailRules = [required, email, this.emailMatch];

		emailMatch(value: string): boolean | string {
			if (value !== this.newEmail) {
				return 'Les adresses e-mail ne correspondent pas';
			}
			return true;
		}
		isFormValid(): boolean {
			return this.$refs.form.validate();
		}

		async updateEmail(): Promise<void> {
			try {
				const response = await updateUtilisateurApi({ email: this.newEmail });
				if (response && 'data' in response) {
					this.utilisateurExterneInfo.email = this.newEmail;
					this.editing = false;
					store.dispatch('notification/add', {
						type: 'success',
						message: 'L\'e-mail a été mis à jour'
					});
					this.newEmailDeux = '';
				}
			} catch (error: any) {
				let errorMessage =
					'Une erreur est survenue lors de la mise à jour de l\'e-mail.';
				if (error.response && error.response.data && error.response.data.error) {
					errorMessage += ` Message : ${error.response.data.error}`;
				} else {
					errorMessage += ` Erreur : ${error.message}`;
				}
				store.dispatch('notification/add', {
					type: 'error',
					message: errorMessage
				});
			}
		}
		toggleEdit(): void {
			this.editing = !this.editing;
			this.newEmail = this.utilisateurExterneInfo.email;
			this.newEmailDeux = '';
		}
		mounted(): void {
			if (!this.utilisateurExterneInfo.email) {
				this.editing = true;
			}
		}
	}
</script>
